import { NetworkStatus } from 'apollo-client';
import { SpacingBlock } from 'components/spacing-block';
import Spinner from 'components/widget/prices/prices-table/tables/history/affiliation/Spinner';
import { Button } from 'ds/components/button';
import { useLocale } from 'locale';
import { isNil, noop } from 'lodash';
import React, { Dispatch, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { StepsContent } from 'screens/Investors/Wizard/StepsContent';
import { IInvestorPreferences, LoadType, MutationType } from 'store/sagas/apiService/types';
import { RootAction, State } from 'store/state';
import { Domain } from 'store/state/domainData';
import { investorPreferencesSelector } from 'store/state/domainData/selectors/common';
import { investorPreferencesDataSelector } from 'store/state/domainData/selectors/investors';
import { inlineMutate } from 'store/state/mutationsResponse/actions';
import { NoPreferencesText, NoPreferencesTitle, NoPreferencesWrapper } from './styled';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { Route } from 'config/routes';
import { navigateTo } from 'store/state/router/actions';


const InvestorsPreferencesTabBase: React.FC<{
  savedPreferences?: IInvestorPreferences;
  investorPreferences?: Domain<LoadType.InvestorPreferences>;
  onUpdatePreferences: (data: any) => void;
  navigateToWizard: () => void;
}> = ({
  savedPreferences,
  investorPreferences,
  onUpdatePreferences,
  navigateToWizard,
}) => {
  const { t } = useLocale();
  const [ isLoading, setIsLoading ] = useState(true);
  const screen = useScreenBreakpoint();
  const isMobile = screen === 1;

  useEffect(() => {
    if (investorPreferences.networkStatus === NetworkStatus.ready) {
      setIsLoading(false);
    }
  }, [ setIsLoading, investorPreferences ]);

  if (isLoading) {
    return (
      <>
        <SpacingBlock mTop={5} />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spinner />
        </div>
        <SpacingBlock mTop={5} />
      </>
    );
  }

  if (isNil(savedPreferences) || isNil(savedPreferences.budget) || isNil(savedPreferences.goal) || isNil(savedPreferences.hasProperty) || isNil(savedPreferences.places)) {
    return (
      <NoPreferencesWrapper>
        <NoPreferencesTitle>{t('investors.profile.noPreferences.title', { isMobile })}</NoPreferencesTitle>
        <NoPreferencesText>{t('investors.profile.noPreferences.text', { isMobile })}</NoPreferencesText>
        <Button size="extraLarge" onClick={navigateToWizard}>{t('investors.profile.noPreferences.button', { isMobile })}</Button>
      </NoPreferencesWrapper>
    );
  }

  return (
    <StepsContent
      fullActive
      savedPreferences={savedPreferences}
      setActiveArea={noop}
      setSavedAreas={noop}
      onUpdatePreferences={onUpdatePreferences}
      btnText={t('update.data.btn.text')}
    />
  );
};

const mapStateToProps = (state: State) => ({
  savedPreferences: investorPreferencesDataSelector(state),
  investorPreferences: investorPreferencesSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onUpdatePreferences: (data: any) => dispatch(inlineMutate(MutationType.UpdateInvestorPreferences, { input: data })),
  navigateToWizard: () => dispatch(navigateTo(Route.InvestorsWizardPage, {})),
});

export const InvestorsPreferencesTab = connect(mapStateToProps, mapDispatchToProps)(InvestorsPreferencesTabBase);
